'use strict';

if (typeof __GRAPHQL_PARSE_PLUGIN__ === 'boolean' && __GRAPHQL_PARSE_PLUGIN__) {
  module.exports = require('./graphql-tag.stub.js');
} else {
  module.exports = require('./graphql-tag.js');
}
